import React from "react";
import { ModalHeader, ModalBody, Modal } from "reactstrap";
import moment from "moment";
const PricesComparisonDetail = ({ price, closeModal }) => {
  return (
    <Modal
      isOpen={price}
      toggle={() => closeModal(false)}
      className={"modal-warning modal-logut"}
      size="lg"
      style={{ maxWidth: "900px", width: "100%" }}
    >
      <ModalHeader toggle={() => closeModal(false)}>Price info</ModalHeader>
      <ModalBody>
        <table className="table table-striped table-order-station datatable mb-0">
          <thead className="thead-inverse">
            <tr>
              <th>List date</th>
              <th>Vendor</th>
              <th>Brand</th>
              <th>Price</th>
              <th>Normalized price</th>
              <th>Pack</th>
              <th>Unit</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{price ? moment(price.price_details.offer_list_date).utc().format("L") : ""}</td>
              <td>{price.price_details.vendor_name ? price.price_details.vendor_name : "-"}</td>
              <td>{price.price_details.brand ? price.price_details.brand : "-"}</td>
              <td>{price.price_details.price ? price.price_details.price : "-"}</td>
              <td>{price.normalized_price ? price.normalized_price : "-"}</td>
              <td>{price.price_details.items_per_pack ? price.price_details.items_per_pack : "-"}</td>
              <td>{price.price_details.unit ? price.price_details.unit : "-"}</td>
            </tr>
          </tbody>
        </table>
      </ModalBody>
    </Modal>
  );
};

export default PricesComparisonDetail;
